/* Mount only the chosen device's media; inactive video templates do not load. */
if (!customElements.get('slideshow-device-media')) {
  customElements.define('slideshow-device-media', class extends HTMLElement {
    connectedCallback() {
      this.slotElement = this.querySelector('[data-device-media-slot]');
      if (!this.slotElement) return;
      this.breakpoint = window.matchMedia('(max-width: 749px)');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.onDevice = () => this.mount();
      this.onPlayback = () => this.syncPlayback();
      this.breakpoint.addEventListener('change', this.onDevice);
      this.motion.addEventListener('change', this.onPlayback);
      document.addEventListener('visibilitychange', this.onPlayback);
      this.slide = this.closest('.slideshow__slide');
      if (this.slide) {
        this.slideObserver = new MutationObserver(this.onPlayback);
        this.slideObserver.observe(this.slide, {attributes:true,attributeFilter:['inert','aria-hidden']});
      }
      if (window.IntersectionObserver) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.syncPlayback();
        });
        this.visibilityObserver.observe(this);
      } else this.visible = true;
      this.mount();
    }
    mount() {
      const device = this.breakpoint.matches ? 'mobile' : 'desktop';
      if (this.device === device) return;
      const template = this.querySelector(`template[data-device-media="${device}"]`);
      if (!template) return;
      this.pause();
      this.slotElement.replaceChildren(template.content.cloneNode(true));
      this.device = device;
      this.syncPlayback();
    }
    pause() {
      this.slotElement?.querySelectorAll('video').forEach(video => video.pause());
      // Removing external players releases their network/audio work.
      this.slotElement?.querySelectorAll('iframe').forEach(frame => frame.remove());
    }
    syncPlayback() {
      const active = this.visible && !document.hidden && !this.motion.matches && !this.slide?.hasAttribute('inert') && this.slide?.getAttribute('aria-hidden') !== 'true';
      this.slotElement.querySelectorAll('video').forEach(video => {
        if (active) video.play()?.catch(() => {});
        else video.pause();
      });
      const template = this.querySelector(`template[data-device-media="${this.device}"]`);
      if (!active) this.slotElement.querySelectorAll('iframe').forEach(frame => frame.remove());
      else if (template?.content.querySelector('iframe') && !this.slotElement.querySelector('iframe')) this.slotElement.replaceChildren(template.content.cloneNode(true));
    }
    disconnectedCallback() {
      this.pause();
      this.breakpoint?.removeEventListener('change', this.onDevice);
      this.motion?.removeEventListener('change', this.onPlayback);
      document.removeEventListener('visibilitychange', this.onPlayback);
      this.slideObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.device = null;
    }
  });
}
